/* eslint-disable import/prefer-default-export */
import getQuery from '../../utilities/query';
import { cacheUserToken } from '../../utilities/caching';
import { user, getAxiosConnection } from '../../api';
import { handleError } from '../../utilities/errorHandling';
import { NEW_SETTINGS_QUERY_ALL, NEW_SETTINGS_QUERY_ALL_AUTH } from '../../utilities/sharedQueries';

const queryClient = getQuery();

export const USER_SIGNUP = 'user.signup';
export const EMAIL_VERIFICATION_SEND = 'email.verification';
export const EMAIL_VERIFY_BY_CODE = 'email.verify.by.code';
export const EMAIL_VERIFICATION_CHECK = 'email.isVerified';
export const PHONE_VERIFICATION_SEND = 'phone.verification';
export const PHONE_VERIFICATION_CHECK = 'phone.isVerified';
export const PHONE_VERIFICATION_SEND_AUTHY = 'phone.phoneVerifyAuthyId';

export const EMAIL_VALIDATE_WAITING_LIST_CHECK = 'email.validateWaitingListEmail';

export const PARTIAL_SIGN_UP = 'user.partialSignup';

export const USER_LOGIN = 'user.login';

export const REQUEST_RESET_PASSWORD = 'email.requestResetPassword';
export const RESET_PASSWORD = 'email.resetPassword';
export const TOTP_EMAIL_VERIFICATION_CHECK = 'totp.emailVerificationCheck';
export const EMAIL_TOTP_CHECK = 'email.isTOTPEnabled';

export const STORE_LIVE_ADDRESSES = 'store.live.addresses';

queryClient.setMutationDefaults(USER_LOGIN, {
  mutationFn: user.login,
  onSuccess: async (result) => {
    if (result && result.access_token) {
      cacheUserToken(result.access_token);
      const axiosConnection = getAxiosConnection();
      axiosConnection.defaults.headers.common.authorization = `${result.access_token}`;
      await queryClient.invalidateQueries(NEW_SETTINGS_QUERY_ALL);
      await queryClient.invalidateQueries(NEW_SETTINGS_QUERY_ALL_AUTH);
    }
  },
});

queryClient.setMutationDefaults(STORE_LIVE_ADDRESSES, {
  mutationFn: user.liveAddresses,
  onError: (error) => {
    handleError(error);
  },
});

queryClient.setMutationDefaults(EMAIL_VERIFICATION_SEND, {
  mutationFn: user.verifyEmail,
  onError: (error) => {
    handleError(error);
  },
});

queryClient.setMutationDefaults(EMAIL_VERIFY_BY_CODE, {
  mutationFn: user.verifyEmailByCode,
  onError: (error) => {
    handleError(error);
  },
});

queryClient.setMutationDefaults(PARTIAL_SIGN_UP, {
  mutationFn: user.partialSignup,
  onSuccess: (result) => {
    if (result && result.accessToken) {
      cacheUserToken(result.accessToken);
      const axiosConnection = getAxiosConnection();
      axiosConnection.defaults.headers.common.authorization = `${result.accessToken}`;
    }
  },
});

queryClient.setMutationDefaults(EMAIL_VALIDATE_WAITING_LIST_CHECK, {
  mutationFn: user.validateWaitingListEmail,
  onError: (error) => {
    handleError(error);
  },
});

queryClient.setMutationDefaults(EMAIL_VERIFICATION_CHECK, {
  mutationFn: user.isEmailVerified,
  onError: (error) => {
    handleError(error);
  },
});

queryClient.setMutationDefaults(PHONE_VERIFICATION_SEND, {
  mutationFn: user.phoneVerify,
  onError: (error) => {
    handleError(error);
  },
});

queryClient.setMutationDefaults(PHONE_VERIFICATION_CHECK, {
  mutationFn: user.phoneCheck,
  onError: (error) => {
    handleError(error);
  },
});

queryClient.setMutationDefaults(USER_SIGNUP, {
  mutationFn: user.signup,
  onSuccess: (result) => {
    if (result && result.accessToken) {
      cacheUserToken(result.accessToken);
    }
    const axiosConnection = getAxiosConnection();
    axiosConnection.defaults.headers.common.authorization = `${result.accessToken}`;
  },
});

queryClient.setMutationDefaults(PHONE_VERIFICATION_SEND_AUTHY, {
  mutationFn: user.phoneVerifyAuthyId,
  onError: (error) => {
    handleError(error);
  },
});

queryClient.setMutationDefaults(REQUEST_RESET_PASSWORD, {
  mutationFn: user.requestResetPassword,
});

queryClient.setMutationDefaults(RESET_PASSWORD, {
  mutationFn: user.resetPassword,
});

queryClient.setMutationDefaults(EMAIL_TOTP_CHECK, {
  mutationFn: user.resetPasswordCheckEmail,
});

queryClient.setMutationDefaults(TOTP_EMAIL_VERIFICATION_CHECK, {
  mutationFn: user.verifyTOTPByEmail,
});
